import './ByzzerMask.scss';
import {ReactNode} from "react";
import cx from "classnames";
import React from 'react';

export type ByzzerMaskProps = {
    className?: string;
    theme?: 'light' | 'dark' | string;
    loading?: boolean;
    show?: boolean;
    children?: ReactNode;
}

const baseClassName = 'byzzer-mask';

export function ByzzerMask(
    {
        className,
        theme = 'light',
        loading = false,
        show = loading,
        children
    }: ByzzerMaskProps) {


    if (!show) return null;

    return (
        <div className={cx(baseClassName, className, {
            [`${baseClassName}--${theme}`]: theme
        })}>
            {loading && (
                <svg className={`${baseClassName}__loading-spinner`} viewBox="0 0 100 100"
                     xmlns="http://www.w3.org/2000/svg">
                    <circle pathLength={1} cx="50" cy="50" r="45"/>
                </svg>
            )}
            {children && (
                <div className={`${baseClassName}__message`}>{children}</div>
            )}
        </div>
    );
}
